<template>
    <div>
        <b-breadcrumb :items="items" />
        <div class="container-fluid" style="background-color: white">
            <h4 class="text-center pt-3 text-bold">ใบจ่ายเงินเดือน</h4>
            <h5 class="text-center text-bold p-1">บริษัท สมบูรณ์ แพ็คเกจจิ้ง(888) จำกัด</h5>
            <h5 class="text-center">
                <label class="text-bold">รหัส &nbsp;&nbsp;</label>{{employee.employee_no}} &nbsp;&nbsp;&nbsp;&nbsp;
                <label class="text-bold">ชื่อ-นามสกุล &nbsp;&nbsp;</label>{{employee.name}}&nbsp;&nbsp;&nbsp;&nbsp;
                <label class="text-bold">แผนก &nbsp;&nbsp;</label>
                {{employee.occupation && employee.occupation.department ? employee.occupation.department.name : "-"}}&nbsp;&nbsp;&nbsp;&nbsp;
                <label class="text-bold">วิธีการชำระเงิน &nbsp;&nbsp;</label>{{employee.transaction && employee.transaction.transaction_type ? employee.transaction.transaction_type.name : "-"}}&nbsp;&nbsp;&nbsp;&nbsp;
                <label class="text-right">เงินเดือน</label> {{employee.salary ? employee.salary.salary : 0 | currency}}
                <label class="text-bold">เลขที่บัญชี &nbsp;&nbsp;</label>
                <template v-if="employee.transaction">
                    {{employee.transaction.account_name}}
                </template>
                <template v-else>
                    -
                </template>
            </h5>

            <div class="table-responsive">
                <table style="text-align: center;min-width: 700px" class="table table-bordered" >
                    <thead>
                    <tr>
                        <th width="32%">
                            รายได้
                            <br>
                            Earnings
                        </th>
                        <th width="18%">
                            จำนวนเงิน
                            <br>
                            Amount
                        </th>
                        <th width="32%">
                            รายการหัก
                            <br>
                            Deductions
                        </th>
                        <th width="18%">
                            จำนวนเงิน
                            <br>
                            Amount
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td class="text-left" >
                            <p class="col-form-label mt-1">วันทำงาน (ไม่รวมวันอาทิตย์)</p>
                            <p class="col-form-label mt-1">ค่าล่วงเวลา*1</p>
                            <p class="col-form-label mt-1">ค่าล่วงเวลา*1.5</p>
                            <p class="col-form-label mt-1">วันหยุด 2 แรง</p>
                            <p class="col-form-label mt-1">ทำงานไม่เต็มวัน</p>
                            <p class="col-form-label mt-1">สวัสดิการ/เบี้ยขยัน</p>
                            <p class="col-form-label mt-1">สวัสดิการ/ค่าห้อง</p>
                            <p class="col-form-label mt-1">เงินค้างได้รับ</p>
                            <p class="col-form-label mt-1">เงินได้จากคอมมิชชั่น</p>
                            <p class="col-form-label mt-1">เงินได้จากโบนัส</p>
                            <p class="col-form-label mt-1">เงินได้อื่นๆ</p>
                            <p class="col-form-label mt-1">หมายเหตุรายได้อื่นๆ</p>
                            <p class="col-form-label mt-1">
                                <b>ยอดขายของเซลล์</b><br>
                                <span>- เช็ค : {{paymentSalary.note_sum_cheque | currency}}</span><br>
                                <span>- เงินโอน : {{paymentSalary.note_sum_transfer | currency}}</span><br>
                                <span>- เงินสด : {{paymentSalary.note_sum_cash | currency}}</span><br>
                                <span style="font-weight:bold">
                                    รวม :{{parseFloat(paymentSalary.note_sum_cheque)
                                    + parseFloat(paymentSalary.note_sum_transfer)
                                    + parseFloat(paymentSalary.note_sum_cash) | currency}}
                                </span><br>

                            </p>
                        </td>

                        <td class="text-left">
                            <input type="number" class="text-right form-control mt-1"
                                   v-model="paymentSalary.income_salary" />
                            <input type="number" class="text-right form-control mt-1"
                                   v-model="paymentSalary.income_overtime_one" />
                            <input type="number" class="text-right form-control mt-1"
                                   v-model="paymentSalary.income_overtime_one_half" />
                            <input type="number" class="text-right form-control mt-1"
                                   v-model="paymentSalary.income_holiday" />
                            <input type="number" class="text-right form-control mt-1"
                                   v-model="paymentSalary.income_half_day_work" />
                            <input type="number" class="text-right form-control mt-1"
                                   v-model="paymentSalary.income_benefits_bonus" />
                            <input type="number" class="text-right form-control mt-1"
                                   v-model="paymentSalary.income_benefits_rental_fee" />
                            <input type="number" class="text-right form-control mt-1"
                                   v-model="paymentSalary.income_accrued" />
                            <input type="number" class="text-right form-control mt-1"
                                   v-model="paymentSalary.income_commission" />
                            <input type="number" class="text-right form-control mt-1"
                                   v-model="paymentSalary.income_bonus_sale" />
                            <input type="number" class="text-right form-control mt-1"
                                   v-model="paymentSalary.income_other"/>
                            <textarea class="form-control mt-1"
                                      v-model="paymentSalary.reason_income"></textarea>
                        </td>
                        <td class="text-left" >
                            <p class="col-form-label mt-1">เงินประกันสังคม</p>
                            <p class="col-form-label mt-1">ร้านค้า</p>
                            <p class="col-form-label mt-1">หักค่าไฟฟ้า/ค่าเช่าห้อง/ค่าน้ำ</p>
                            <p class="col-form-label mt-1">หักขาดงาน</p>
                            <p class="col-form-label mt-1">หักค่าอาหาร</p>
                            <p class="col-form-label mt-1">หักค่าเงินเบิกล่วงหน้า</p>
                            <p class="col-form-label mt-1">ค่าธรรมเนียมเงินเข้า Bank</p>
                            <p class="col-form-label mt-1">ค่าโฟมเสียหาย/คืนของ</p>
                            <p class="col-form-label mt-1">หักวันอาทิตย์ได้ 1 แรง</p>
                            <p class="col-form-label mt-1">หักค่าบัตรพนักงาน</p>
                            <p class="col-form-label mt-1">ค่าประกันความเสียหาย</p>
                            <p class="col-form-label mt-1">หักภาษีเงินได้บุคคลธรรมดา</p>
                            <p class="col-form-label mt-1">หักค่าประกันห้อง</p>
                            <p class="col-form-label mt-1">หักค่าบริการ</p>
                            <p class="col-form-label mt-1">ค่าโทรศัพท์</p>
                            <p class="col-form-label mt-1">ค่าขนส่ง</p>
                            <p class="col-form-label mt-1">รับค่าแก๊สรถยนต์คืน</p>
                            <p class="col-form-label mt-1">รายจ่ายอื่นๆ</p>
                            <p class="col-form-label mt-1">หมายเหตุรายจ่ายอื่นๆ</p>
                        </td>

                        <td class="text-left">
                            <input type="number" class="text-right form-control mt-1"
                                   v-model="paymentSalary.cost_social_security" />
                            <input type="number" class="text-right form-control mt-1"
                                   v-model="paymentSalary.cost_cooperative_store" />
                            <input type="number" class="text-right form-control mt-1"
                                   v-model="paymentSalary.cost_rental_fee" />
                            <input type="number" class="text-right form-control mt-1"
                                   v-model="paymentSalary.cost_absence_from_work" />
                            <input type="number" class="text-right form-control mt-1"
                                   v-model="paymentSalary.cost_meal" />
                            <input type="number" class="text-right form-control mt-1"
                                   v-model="paymentSalary.cost_advance" />
                            <input type="number" class="text-right form-control mt-1"
                                   v-model="paymentSalary.cost_bank_charge" />
                            <input type="number" class="text-right form-control mt-1"
                                   v-model="paymentSalary.cost_damages" />
                            <input type="number" class="text-right form-control mt-1"
                                   v-model="paymentSalary.cost_sunday" />
                            <input type="number" class="text-right form-control mt-1"
                                   v-model="paymentSalary.cost_employee_card" />
                            <input type="number" class="text-right form-control mt-1"
                                   v-model="paymentSalary.cost_damage_security_deposit" />
                            <input type="number" class="text-right form-control mt-1"
                                   v-model="paymentSalary.cost_personal_income_tax"/>
                            <input type="number" class="text-right form-control mt-1"
                                   v-model="paymentSalary.cost_room_security_deposit" />
                            <input type="number" class="text-right form-control mt-1"
                                   v-model="paymentSalary.cost_service" />
                            <input type="number" class="text-right form-control mt-1"
                                   v-model="paymentSalary.cost_phone" />
                            <input type="number" class="text-right form-control mt-1"
                                   v-model="paymentSalary.cost_transport_fee" />
                            <input type="number" class="text-right form-control mt-1"
                                   v-model="paymentSalary.cost_gas_car" />
                            <input type="number" class="text-right form-control mt-1"
                                   v-model="paymentSalary.cost_other"/>
                            <textarea class="form-control mt-1"
                                      v-model="paymentSalary.reason_cost">
                            </textarea>
                        </td>
                    </tr>
                    <tr class="text-bold">
                        <td>รวมเงินได้ (Total Earnings)</td>
                        <td >
                            {{calculateTotalEarning > 0 ? calculateTotalEarning : 0 | currency}}
                        </td>
                        <td>รวมรายการหัก (Total Deductions)</td>
                        <td>
                            {{calculateTotalDeduction > 0 ? calculateTotalDeduction : 0 | currency}}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="row" >
                <div class="col-xl-9 col-12 table-responsive">
                    <table style="text-align: center"   class="table table-bordered">
                        <thead>
                        <tr>
                            <th>ภาษีสะสมต่อปี</th>
                            <th>ประกันสังคมสะสม</th>
                            <th>ผู้ออกเอกสาร</th>
                            <th>ผู้อนุมัติ</th>
                            <th>ลงชื่อพนักงาน</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>
                                {{paymentSalary.cumulative_tax ? paymentSalary.cumulative_tax : 0 | currency}}
                            </td>
                            <td>
                                {{paymentSalary.cumulative_social_security ? paymentSalary.cumulative_social_security : 0 | currency}}
                            </td>
                            <td>
                                {{paymentSalary.user ? paymentSalary.user.name : ''}}
                            </td>
                            <td></td>
                            <td>
                                {{paymentSalary.employee}}
                            </td>
                        </tr>
                        </tbody>
                    </table >
                </div>

                <div class="col-xl-3 col-12 table-responsive pl-0">
                    <table style="text-align: center"  class="table table-bordered">
                        <thead>
                        <tr>
                            <th style="min-width: 50%">วันที่จ่าย</th>
                            <td>
                                {{paymentSalary.payment_date | moment('DD/MM/YYYY')}}
                            </td>
                        </tr>
                        <tr>
                            <th style="min-width: 50%">เงินรับสุทธิ</th>
                            <td>
                                {{calculateNetTotal > 0 ? calculateNetTotal : 0 | currency}}
                            </td>
                        </tr>
                        </thead>
                    </table>
                </div>
            </div>

            <template v-if="paymentSalary.id == last_payment">
                <b-row class="mt-1 pb-3">
                    <div class="col text-center">
                        <button type="button" class="btn btn-success"
                            @click="savePaymentSalarySlip">
                            <icon name="save" style="width: 25px"></icon> บันทึก</button>
                        &nbsp;&nbsp;
                        <button type="button" class="btn btn-outline-secondary"
                            @click="goToPaymentSalaryHistory">
                            <icon name="times" style="width: 25px"></icon> ยกเลิก
                        </button>
                    </div>
                </b-row>
            </template>
        </div>
<!--        <pre class="alert-success">{{employee}}</pre>-->
        <!--<pre class="alert-primary">{{paymentSalary}}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex";

    export default {
        name: "PaymentSalarySlip",
        components: {
        },
        created(){
            // this.$store.dispatch("paymentSalaryList/setElectricityBill",this.rentalFeeForm.id);
        },
        data() {
            return {
                items: [
                    {
                        text: "รายการประวัติการจ่ายเงินเดือน",
                        to: {name: "payment-salary-history"}
                    },
                    {
                        text: "เพิ่มเติม",
                        active: true
                    }
                ],

            }
        },
        computed: {
            ...mapState({
                paymentSalary:state=>{
                    return state.PaymentSalary.paymentSalary
                },
                employee:state=>{
                    return state.Employee.employeeForm;
                },
                last_payment:state=>{
                    return state.PaymentSalary.last_payment;
                },
            }),
            calculateTotalEarning(){
                if(this.paymentSalary.income_salary < 0 || !this.paymentSalary.income_salary){
                    this.paymentSalary.income_salary = 0
                }
                if(this.paymentSalary.income_overtime_one < 0 || !this.paymentSalary.income_overtime_one){
                    this.paymentSalary.income_overtime_one = 0
                }
                if(this.paymentSalary.income_overtime_one_half < 0 || !this.paymentSalary.income_overtime_one_half){
                    this.paymentSalary.income_overtime_one_half = 0
                }
                if(this.paymentSalary.income_holiday < 0 || !this.paymentSalary.income_holiday){
                    this.paymentSalary.income_holiday = 0
                }
                if(this.paymentSalary.income_half_day_work < 0 || !this.paymentSalary.income_half_day_work){
                    this.paymentSalary.income_half_day_work = 0
                }
                if(this.paymentSalary.income_benefits_bonus < 0 || !this.paymentSalary.income_benefits_bonus){
                    this.paymentSalary.income_benefits_bonus = 0
                }
                if(this.paymentSalary.income_benefits_rental_fee < 0 || !this.paymentSalary.income_benefits_rental_fee){
                    this.paymentSalary.income_benefits_rental_fee = 0
                }
                if(this.paymentSalary.income_accrued < 0 || !this.paymentSalary.income_accrued){
                    this.paymentSalary.income_accrued = 0
                }
                if(this.paymentSalary.income_commission < 0 || !this.paymentSalary.income_commission){
                    this.paymentSalary.income_commission = 0
                }
                if(this.paymentSalary.income_bonus_sale < 0 || !this.paymentSalary.income_bonus_sale){
                    this.paymentSalary.income_bonus_sale = 0
                }
                if(this.paymentSalary.income_other < 0 || !this.paymentSalary.income_other){
                    this.paymentSalary.income_other = 0
                }
                this.paymentSalary.total_income =
                    parseFloat(this.paymentSalary.income_salary)
                    +parseFloat(this.paymentSalary.income_overtime_one)
                    +parseFloat(this.paymentSalary.income_overtime_one_half)
                    +parseFloat(this.paymentSalary.income_holiday)
                    +parseFloat(this.paymentSalary.income_half_day_work)
                    +parseFloat(this.paymentSalary.income_benefits_bonus)
                    +parseFloat(this.paymentSalary.income_benefits_rental_fee)
                    +parseFloat(this.paymentSalary.income_accrued)
                    +parseFloat(this.paymentSalary.income_commission)
                    +parseFloat(this.paymentSalary.income_bonus_sale)
                    +parseFloat(this.paymentSalary.income_other)
                console.log(this.paymentSalary.total_income);
                return this.paymentSalary.total_income;
            },
            calculateTotalDeduction(){
                if(this.paymentSalary.cost_social_security < 0 || !this.paymentSalary.cost_social_security){
                    this.paymentSalary.cost_social_security = 0
                }
                if(this.paymentSalary.cost_cooperative_store < 0 || !this.paymentSalary.cost_cooperative_store){
                    this.paymentSalary.cost_cooperative_store = 0
                }
                if(this.paymentSalary.cost_rental_fee < 0 || !this.paymentSalary.cost_rental_fee){
                    this.paymentSalary.cost_rental_fee = 0
                }
                if(this.paymentSalary.cost_absence_from_work < 0 || !this.paymentSalary.cost_absence_from_work){
                    this.paymentSalary.cost_absence_from_work = 0
                }
                if(this.paymentSalary.cost_meal < 0 || !this.paymentSalary.cost_meal){
                    this.paymentSalary.cost_meal = 0
                }
                if(this.paymentSalary.cost_advance < 0 || !this.paymentSalary.cost_advance){
                    this.paymentSalary.cost_advance = 0
                }
                if(this.paymentSalary.cost_bank_charge < 0 || !this.paymentSalary.cost_bank_charge){
                    this.paymentSalary.cost_bank_charge = 0
                }
                if(this.paymentSalary.cost_damages < 0 || !this.paymentSalary.cost_damages){
                    this.paymentSalary.cost_damages = 0
                }
                if(this.paymentSalary.cost_sunday < 0 || !this.paymentSalary.cost_sunday){
                    this.paymentSalary.cost_sunday = 0
                }
                if(this.paymentSalary.cost_employee_card < 0 || !this.paymentSalary.cost_employee_card){
                    this.paymentSalary.cost_employee_card = 0
                }
                if(this.paymentSalary.cost_damage_security_deposit < 0 || !this.paymentSalary.cost_damage_security_deposit){
                    this.paymentSalary.cost_damage_security_deposit = 0
                }
                if(this.paymentSalary.cost_personal_income_tax < 0 || !this.paymentSalary.cost_personal_income_tax){
                    this.paymentSalary.cost_personal_income_tax = 0
                }
                if(this.paymentSalary.cost_room_security_deposit < 0 || !this.paymentSalary.cost_room_security_deposit){
                    this.paymentSalary.cost_room_security_deposit = 0
                }
                if(this.paymentSalary.cost_service < 0 || !this.paymentSalary.cost_service){
                    this.paymentSalary.cost_service = 0
                }
                if(this.paymentSalary.cost_other < 0 || !this.paymentSalary.cost_other){
                    this.paymentSalary.cost_other = 0
                }
                if(this.paymentSalary.cost_gas_car < 0 || !this.paymentSalary.cost_gas_car){
                    this.paymentSalary.cost_gas_car = 0
                }
                if(this.paymentSalary.cost_other < 0 || !this.paymentSalary.cost_other){
                    this.paymentSalary.cost_other = 0
                }
                if(this.paymentSalary.total_cost < 0 || !this.paymentSalary.total_cost){
                    this.paymentSalary.total_cost = 0
                }
                this.paymentSalary.total_cost =
                    parseFloat(this.paymentSalary.cost_social_security)
                    +parseFloat(this.paymentSalary.cost_cooperative_store)
                    +parseFloat(this.paymentSalary.cost_rental_fee)
                    +parseFloat(this.paymentSalary.cost_absence_from_work)
                    +parseFloat(this.paymentSalary.cost_meal)
                    +parseFloat(this.paymentSalary.cost_advance)
                    +parseFloat(this.paymentSalary.cost_bank_charge)
                    +parseFloat(this.paymentSalary.cost_damages)
                    +parseFloat(this.paymentSalary.cost_sunday)
                    +parseFloat(this.paymentSalary.cost_employee_card)
                    +parseFloat(this.paymentSalary.cost_damage_security_deposit)
                    +parseFloat(this.paymentSalary.cost_personal_income_tax)
                    +parseFloat(this.paymentSalary.cost_room_security_deposit)
                    +parseFloat(this.paymentSalary.cost_service)
                    +parseFloat(this.paymentSalary.cost_other)
                    +parseFloat(this.paymentSalary.cost_gas_car)
                    +parseFloat(this.paymentSalary.cost_transport_fee)
                    +parseFloat(this.paymentSalary.cost_phone)
                console.log(this.paymentSalary.total_cost);
                return this.paymentSalary.total_cost;
            },
            calculateNetTotal() {
                this.paymentSalary.net_total =
                    parseFloat(this.paymentSalary.total_income)
                    - parseFloat(this.paymentSalary.total_cost);
                return this.paymentSalary.net_total;
            },
        },
        methods:{
            getPaymentSalaryList(){
                const page = this.dataPaginate.current_page;

                this.$store.dispatch("PaymentSalary/setPaymentSalary",{
                    employee_id : this.employeeForm.id,
                    page : page
                })
            },
            savePaymentSalarySlip(){
                this.$store.dispatch("PaymentSalary/savePaymentSalary",{
                    id : this.paymentSalary.id,
                    data : this.paymentSalary
                }).then(data=>{
                    this.$router.push({
                        name : "payment-salary-history"
                    })
                })
            },
            goToPaymentSalaryHistory(){
                this.$router.push({
                    name : "payment-salary-history"
                })
            },
        }

    }
</script>

<style scoped>
    .text-bold{
        font-weight: bold;
    }

    thead tr{
        background-color: #ffbf00;
        color: white;
    }
    thead td{
        color: black;
        background-color: #ebebe0;
    }

    .span-form{
        background-color: #e9ecef;
        opacity: 1;
    }
</style>
